/**
 * Telegram Notification Utility
 * Sends order notifications to Telegram
 */

const TELEGRAM_BOT_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
const TELEGRAM_CHAT_ID = process.env.REACT_APP_TELEGRAM_CHAT_ID;

/**
 * Escape HTML special characters
 */
const escapeHtml = (text) => {
  if (!text) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

/**
 * Format order details for Telegram message (HTML format)
 */
const formatOrderMessage = (order) => {
  const { orderId, customerInfo, items, totalAmount, shippingAddress, paymentMethod } = order;

  // Format items list
  const itemsList = items.map((item, index) =>
    `${index + 1}. ${escapeHtml(item.name)}\n   • Số lượng: ${item.quantity}\n   • Giá: ${formatPrice(item.price)}đ`
  ).join('\n\n');

  // Create message using HTML format
  const message = `
🔔 <b>ĐƠN HÀNG MỚI</b>

📦 <b>Mã đơn hàng:</b> ${escapeHtml(orderId)}

👤 <b>Thông tin khách hàng:</b>
• Tên: ${escapeHtml(customerInfo.name)}
• Email: ${escapeHtml(customerInfo.email)}
• SĐT: ${escapeHtml(customerInfo.phone)}

📍 <b>Địa chỉ giao hàng:</b>
${escapeHtml(shippingAddress)}

🛍 <b>Sản phẩm:</b>
${itemsList}

💰 <b>Tổng tiền:</b> ${formatPrice(totalAmount)}đ
💳 <b>Phương thức thanh toán:</b> ${paymentMethod === 'cod' ? 'Thanh toán khi nhận hàng (COD)' : escapeHtml(paymentMethod)}

⏰ <b>Thời gian:</b> ${escapeHtml(new Date().toLocaleString('vi-VN'))}
`;

  return message;
};

/**
 * Format price with thousands separator
 */
const formatPrice = (price) => {
  return new Intl.NumberFormat('vi-VN').format(price);
};

/**
 * Send notification to Telegram
 */
export const sendTelegramNotification = async (order) => {
  // Check if Telegram config is available
  if (!TELEGRAM_BOT_TOKEN || !TELEGRAM_CHAT_ID) {
    console.warn('Telegram configuration is missing. Skipping notification.');
    return { success: false, error: 'Missing configuration' };
  }

  try {
    const message = formatOrderMessage(order);
    const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: TELEGRAM_CHAT_ID,
        text: message,
        parse_mode: 'HTML',
      }),
    });

    const data = await response.json();

    if (data.ok) {
      console.log('Telegram notification sent successfully');
      return { success: true };
    } else {
      console.error('Telegram API error:', data);
      return { success: false, error: data.description };
    }
  } catch (error) {
    console.error('Error sending Telegram notification:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send test notification to verify Telegram setup
 */
export const sendTestNotification = async () => {
  const testOrder = {
    orderId: 'TEST-' + Date.now(),
    customerInfo: {
      name: 'Khách hàng test',
      email: 'test@example.com',
      phone: '0123456789',
    },
    items: [
      {
        name: 'Kính mát Ray-Ban',
        quantity: 1,
        price: 1500000,
      },
    ],
    totalAmount: 1500000,
    shippingAddress: '123 Đường ABC, Quận 1, TP.HCM',
    paymentMethod: 'cod',
  };

  return sendTelegramNotification(testOrder);
};
